export default function updateTabNames(prev: Map<string, string>, code: string, name: string) {
  const updated = new Map(prev);
  updated.set(code, name);
  return updated;
}
